import * as axiosService from "./axiosService";

//save basic information of shipper
export const getAllKeys = () => {
  return axiosService.Get(
    process.env.REACT_APP_LOKALIZE_API_URL + `/GetAllKeys/web`,
  );
};

export const getLanguagePack = (lang) => {
    return axiosService.Get(
      process.env.REACT_APP_LOKALIZE_API_URL + `/GetAllKeys/web/` + lang,
      );
};

export const getAllLanguage = () => {
    return axiosService.Get(
      process.env.REACT_APP_LOKALIZE_API_URL + `/GetProjectLangauges`,
      
    );
  };
  